(function resolveCompilationLanding() {
  var match = window.location.pathname.match(/^\/(?:([a-z]{2}(?:-[a-z]{2})?)\/)?blogs\/compilations\/([a-z0-9-]+)$/i);
  if (!match) return;

  var localePrefix = match[1] ? '/' + match[1] : '';
  var topic = match[2];
  var topics = [
    'apples-and-crabapples',
    'berries-and-currants',
    'grafting-work',
    'grapes-and-vines',
    'haskaps-honeyberries',
    'pears-and-rootstock-trials',
    'plum-and-cherry-hybrids',
    'propagation-by-cuttings',
    'rootstocks-and-seedlings',
    'seeds-and-stratification',
    'tomatoes-and-peppers',
    'walnuts-and-oaks',
    'wildlife-and-habitat'
  ];
  if (topics.indexOf(topic) === -1) return;

  var params = new URLSearchParams(window.location.search);
  var focus = params.get('focus');
  var post = params.get('post');
  var month = new Date().getMonth() + 1;
  var currentSeason = month >= 3 && month <= 5 ? 'spring' : month >= 6 && month <= 8 ? 'summer' : month >= 9 && month <= 11 ? 'fall' : 'winter';

  function redirect(season) {
    var target = localePrefix + '/blogs/compilations/' + topic + '-' + season;
    var query = params.toString();
    window.location.replace(target + (query ? '?' + query : ''));
  }

  if (!focus) {
    redirect(currentSeason);
    return;
  }

  var mapUrl = window.OSN_THEME && window.OSN_THEME.compilationFocusSeasonsUrl;
  if (!mapUrl) {
    redirect(currentSeason);
    return;
  }
  fetch(mapUrl, { credentials: 'same-origin', cache: 'force-cache' })
    .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('focus map unavailable')); })
    .then(function (map) {
      var topicMap = map[topic] || {};
      var seasons = topicMap.f && topicMap.f[focus] ? topicMap.f[focus] : [];
      var season = post && topicMap.p ? topicMap.p[post] : '';
      if (!season && seasons.indexOf(currentSeason) !== -1) season = currentSeason;
      if (!season && seasons.length) season = seasons[0];
      redirect(season || currentSeason);
    })
    .catch(function () { redirect(currentSeason); });
})();

(function initDeferredCardBackgrounds() {
  var selector = '[data-osn-background-image]';
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '320px 0px' }) : null;

  function reveal(element) {
    var url = element.getAttribute('data-osn-background-image');
    if (!url) return;
    element.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
    element.removeAttribute('data-osn-background-image');
  }

  function scan(root) {
    var elements = [];
    if (root && root.matches && root.matches(selector)) elements.push(root);
    if (root && root.querySelectorAll) elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    elements.forEach(function (element) {
      if (observer) observer.observe(element);
      else reveal(element);
    });
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

(function initStoreNavigation() {
  document.querySelectorAll('.store-mobile-menu[data-osn-default-menu]').forEach(function (menu) {
    menu.addEventListener('toggle', function () {
      if (!menu.open) return;
      var group = menu.querySelector('[data-osn-mobile-category="' + menu.dataset.osnDefaultMenu + '"]');
      if (!group) return;
      var toggle = group.querySelector('[data-osn-nav-toggle]');
      var panel = group.querySelector('[data-osn-nav-panel]');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      group.classList.add('is-open');
    });
  });
  function closeGroup(group, restoreFocus) {
    if (!group) return;
    var toggle = group.querySelector(':scope > [data-osn-nav-toggle], :scope > .store-mobile-menu__parent [data-osn-nav-toggle]');
    var panel = group.querySelector(':scope > [data-osn-nav-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    group.classList.remove('is-open');
    if (restoreFocus) toggle.focus();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-osn-nav-toggle]');
    if (toggle) {
      event.preventDefault();
      var group = toggle.closest('[data-osn-nav-group]');
      var panel = group ? group.querySelector(':scope > [data-osn-nav-panel]') : null;
      if (!panel) return;
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('[data-osn-nav-group].is-open').forEach(function (other) {
        if (other !== group) closeGroup(other, false);
      });
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.hidden = !willOpen;
      group.classList.toggle('is-open', willOpen);
      return;
    }
    if (!event.target.closest('[data-osn-nav-group]')) {
      document.querySelectorAll('[data-osn-nav-group].is-open').forEach(function (group) {
        closeGroup(group, false);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var group = document.activeElement && document.activeElement.closest('[data-osn-nav-group].is-open');
    if (group) closeGroup(group, true);
  });
})();

(function trackHomeAllSeedsDestination() {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-osn-home-all-seeds]');
    if (!link) return;

    var firstDestination = true;
    try {
      firstDestination = sessionStorage.getItem('osn_storefront_destination_recorded') !== '1';
      sessionStorage.setItem('osn_storefront_destination_recorded', '1');
    } catch (_error) {
      firstDestination = true;
    }

    var width = window.innerWidth;
    var parameters = {
      link_id: link.getAttribute('data-osn-link-id') || 'home-category-all-seeds',
      source_section: link.getAttribute('data-osn-source-section') || 'home-category-nav',
      destination_path: new URL(link.href, window.location.origin).pathname,
      device_category: width < 750 ? 'mobile' : width < 990 ? 'tablet' : 'desktop',
      session_context: firstDestination ? 'first_storefront_destination' : 'later_storefront_destination',
      is_first_storefront_destination: firstDestination ? 1 : 0,
      send_to: 'G-QDH0E1G2RS',
      transport_type: 'beacon'
    };
    if (window.__OSN_MEASUREMENT_DEBUG__ === true) parameters.debug_mode = true;

    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'osn_home_all_seeds_click', parameters);
    } else {
      window.dataLayer.push(['event', 'osn_home_all_seeds_click', parameters]);
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  var productSection = document.querySelector('.template-product .product');
  if (!productSection) return;
  // The shared product composition owns the notes on new product templates.
  if (document.querySelector('[data-osn-discovery]')) return;

  var related = productSection.querySelector('.osn-related-compilations');
  var sectionHost = productSection.closest('.shopify-section');
  if (!related || !sectionHost) return;
  var relationText = window.OSN_THEME && window.OSN_THEME.locale && window.OSN_THEME.locale.productRelations || {};

  related.querySelectorAll('.osn-related-compilations__item--focus .osn-related-compilations__eyebrow').forEach(function (node) {
    node.textContent = relationText.fieldNotePhotos || 'Field note photos';
  });
  related.querySelectorAll('.osn-related-compilations__item--focus .osn-related-compilations__cta').forEach(function (node) {
    node.textContent = relationText.readNote || relationText.view || 'View';
  });
  related.querySelectorAll('.osn-related-compilations__item--compilation .osn-related-compilations__eyebrow').forEach(function (node) {
    node.textContent = relationText.fieldNotesTopic || 'Field notes topic';
  });
  related.querySelectorAll('.osn-related-compilations__item--compilation .osn-related-compilations__cta').forEach(function (node) {
    node.textContent = relationText.browse || 'Browse';
  });

  var focusedItems = Array.prototype.slice.call(
    related.querySelectorAll('.osn-related-compilations__item--focus')
  );
  // Publication IDs reflect import order, not when nursery photos were taken.
  // Known observation dates first; unknown/legacy dates keep their prior order.
  focusedItems.sort(function (a, b) {
    var dateA = /^\d{4}-\d{2}-\d{2}/.test(a.dataset.fieldNoteDate || '') ? a.dataset.fieldNoteDate.slice(0,10) : '';
    var dateB = /^\d{4}-\d{2}-\d{2}/.test(b.dataset.fieldNoteDate || '') ? b.dataset.fieldNoteDate.slice(0,10) : '';
    return dateB.localeCompare(dateA);
  });
  focusedItems.forEach(function (item) { item.parentNode.appendChild(item); });
  var topicItems = Array.prototype.slice.call(
    related.querySelectorAll('.osn-related-compilations__item:not(.osn-related-compilations__item--focus)')
  );
  var band = document.createElement('section');
  band.className = 'osn-product-relations';
  band.innerHTML = '<div class="site-width" data-osn-product-relations-band></div>';
  var bandInner = band.querySelector('[data-osn-product-relations-band]');

  if (focusedItems.length) {
    var focused = document.createElement('div');
    focused.className = 'osn-product-relations__focused';
    focused.innerHTML = '<div data-osn-focused-field-notes></div>';
    related.setAttribute('aria-label', relationText.listingLabel || 'Field notes for this listing');
    focused.querySelector('[data-osn-focused-field-notes]').appendChild(related);
    var noteHeading = document.createElement('h2');
    noteHeading.id = 'OsnProductFieldNotes';
    noteHeading.textContent = relationText.noteHeading || relationText.listingLabel || 'Field Notes';
    focused.prepend(noteHeading);
    var noteList = related.querySelector('.osn-related-compilations__list');
    noteList.setAttribute('tabindex', '0');
    noteList.setAttribute('aria-labelledby', noteHeading.id);
    if (focusedItems.length > 1) {
      var swipeNotes = document.createElement('p');
      swipeNotes.className = 'osn-field-notes__swipe';
      swipeNotes.textContent = relationText.swipeNotes || 'Swipe to explore the notes.';
      noteHeading.after(swipeNotes);
    }
    // Move, never clone, existing posts. Keep a bounded first row without
    // losing source links, locale paths or the remaining growing records.
    if (focusedItems.length > 3) {
      var moreNotes = document.createElement('details');
      moreNotes.className = 'osn-field-notes__more';
      var moreSummary = document.createElement('summary');
      moreSummary.textContent = (relationText.moreNotes || 'More Field Notes') + ' (' + (focusedItems.length - 3) + ')';
      var moreList = document.createElement('ul');
      moreList.className = 'osn-related-compilations__list';
      moreList.setAttribute('tabindex', '0');
      moreList.setAttribute('aria-label', relationText.moreNotes || 'More Field Notes');
      focusedItems.slice(3).forEach(function (item) { moreList.appendChild(item); });
      moreNotes.append(moreSummary, moreList);
      focused.appendChild(moreNotes);
    }
    bandInner.appendChild(focused);
  }

  if (topicItems.length) {
    var topics = document.createElement('details');
    topics.className = 'osn-product-relations__topics';
    var summary = document.createElement('summary');
    var summaryText = document.createElement('span');
    var summaryHeading = document.createElement('strong');
    var summaryCopy = document.createElement('small');
    var summaryIcon = document.createElement('span');
    summaryHeading.textContent = relationText.relatedTopics || 'Related field note topics';
    summaryCopy.textContent = relationText.broaderGuides || 'Broader growing guides and seasonal notes';
    summaryText.append(summaryHeading, summaryCopy);
    summaryIcon.setAttribute('aria-hidden', 'true');
    summaryIcon.textContent = '+';
    summary.append(summaryText, summaryIcon);
    topics.appendChild(summary);
    var topicContent = document.createElement('div');
    topicContent.className = 'osn-product-relations__content';
    topicContent.setAttribute('data-osn-topic-field-notes', '');
    topics.appendChild(topicContent);
    var topicRelated = document.createElement('section');
    topicRelated.className = 'osn-related-compilations';
    topicRelated.setAttribute('aria-label', relationText.relatedTopics || 'Related field note topics');
    var topicList = document.createElement('ul');
    topicList.className = 'osn-related-compilations__list';
    topicItems.forEach(function (item) {
      topicList.appendChild(item);
    });
    topicRelated.appendChild(topicList);
    topics.querySelector('[data-osn-topic-field-notes]').appendChild(topicRelated);
    bandInner.appendChild(topics);
  }

  var relatedSeeds = document.querySelector('[data-osn-related-seeds]');
  var insertionHost = relatedSeeds ? relatedSeeds.closest('.shopify-section') : sectionHost;
  insertionHost.insertAdjacentElement('afterend', band);
});

/* OSN_TERMS_20261008_START: native-qualified presentation, no rule or cart mutations. */
(function(){
 'use strict';
 const copy={"en":{"hero.sale":"Sale to October 20 · ships through October","hero.offer":"$30 plant minimum · discounts from $100","toast.minimum":"Add {amount} more in plants to reach the $30 minimum.","toast.tier":"{amount} more in eligible merchandise for {percent}% off your order.","cart.tier.add":"Spend {amount} more in eligible merchandise for {percent}% off your order.","cart.tier.applied":"{percent}% order discount applied","product.bc.fall":"British Columbia: fall plants can’t ship there this season. Seeds can.","product.bc.ribes":"We can’t currently ship currants or gooseberries to British Columbia. Seeds can.","cart.bc.quiet":"Fall plants can’t ship to British Columbia this season. Seeds can.","cart.bc.title":"These plants can’t ship to British Columbia","cart.bc.body":"Fall plants can’t ship to BC this season. Seeds can. Remove the plants, or use an address outside BC.","cart.suggestions":"Available plants from the same collection"},"fr":{"hero.sale":"Vente jusqu’au 20 octobre · expéditions tout octobre","hero.offer":"Minimum de 30 $ en plants · rabais dès 100 $","toast.minimum":"Ajoutez encore {amount} de plants pour atteindre le minimum de 30 $.","toast.tier":"{amount} de plus en articles admissibles pour obtenir {percent} % de rabais sur votre commande.","cart.tier.add":"Dépensez {amount} de plus en articles admissibles pour obtenir {percent} % de rabais sur votre commande.","cart.tier.applied":"Rabais de {percent} % appliqué à la commande","product.bc.fall":"Colombie-Britannique : les plants de la vente d’automne ne peuvent pas y être expédiés cette saison. Les semences peuvent l’être.","product.bc.ribes":"Nous ne pouvons pas actuellement expédier de groseilliers à grappes, de cassissiers ou de groseilliers à maquereau en Colombie-Britannique. Les semences peuvent y être expédiées.","cart.bc.quiet":"Les plants de la vente d’automne ne peuvent pas être expédiés en Colombie-Britannique cette saison. Les semences peuvent l’être.","cart.bc.title":"Ces plants ne peuvent pas être expédiés en Colombie-Britannique","cart.bc.body":"Les plants de la vente d’automne ne peuvent pas être expédiés en Colombie-Britannique cette saison. Les semences peuvent l’être. Retirez les plants ou utilisez une adresse de livraison à l’extérieur de la Colombie-Britannique.","cart.suggestions":"Plants disponibles de la même collection"}};
 const tiers=[{at:10000,percent:5,title:'5% Discount Over $100'},{at:25000,percent:10,title:'10% Discount Over $250'},{at:50000,percent:15,title:'15% Discount Over $500'}];
 const incompatible=new Set(['10% Seeds Discount','15% Seeds Discount','20% Discount','25% Discount']);
 function language(locale){return (locale||document.documentElement.lang||'en').split('-')[0]}
 function isPlant(item){return item.kind==='plant'||/^(trees?|shrubs?|plants?|plant collection)$/i.test(item.product_type||'')}
 function hasPlants(cart){
  const state=cart?.plantMinimum;if(!state||state.currency!==cart.currency)return false;
  return Number.isSafeInteger(state.plantCount)?state.plantCount>0:Number.isSafeInteger(state.subtotal)&&state.subtotal>0;
 }
 function qualify(cart,doc){
  try{const rows=[...doc.querySelectorAll('[data-osn-panel-key]')];if(!Array.isArray(cart?.items)||rows.length!==cart.items.length||cart.items.some(item=>{const row=rows.find(n=>n.dataset.osnPanelKey===item.key);return !row||Number(row.querySelector('input[name="updates[]"]')?.value)!==item.quantity}))return null;
   const policy=doc.querySelector('[data-osn-plant-minimum-state]');if(!policy)return null;const state=JSON.parse(policy.textContent);if(state.currency!==cart.currency||!Number.isSafeInteger(state.subtotal)||state.subtotal<0)return null;return {...cart,plantMinimum:state};
  }catch(_){return null}
 }
 function money(cents,locale){return new Intl.NumberFormat(locale+'-CA',{style:'currency',currency:'CAD',currencyDisplay:'narrowSymbol',minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100)}
 function amounts(cart){
  if(!cart||cart.currency!=='CAD'||!Array.isArray(cart.items)||!cart.items.length||!Number.isSafeInteger(cart.original_total_price)||!Number.isSafeInteger(cart.total_price)||cart.total_price<0||cart.items.some(i=>i.gift_card))return null;
  const discounts=cart.items.flatMap(i=>i.line_level_discount_allocations||[]).filter(a=>a.amount>0).map(a=>a.discount_application?.title);
  if(discounts.some(title=>!title||incompatible.has(title)))return null;
  const order=(cart.cart_level_discount_applications||[]).map(d=>d.total_allocated_amount);
  if(order.some(n=>!Number.isSafeInteger(n)||n<0))return null;
  return Math.min(cart.original_total_price,cart.total_price+order.reduce((a,n)=>a+n,0));
 }
 function progress(cart,locale,pattern){
  const lang=language(locale),text=copy[lang];if(!text||!hasPlants(cart))return '';
  const basis=amounts(cart);if(basis===null)return '';const next=tiers.find(t=>t.at>basis);if(!next)return '';
  return text[pattern].replace('{amount}',money(next.at-basis,lang)).replace('{percent}',next.percent);
 }
 function minimum(cart,state,locale){
  const lang=language(locale),text=copy[lang];if(!text||cart?.currency!=='CAD'||!state?.blocked||!Number.isSafeInteger(state.remaining)||state.remaining<=0)return '';
  return text['toast.minimum'].replace('{amount}',money(state.remaining,lang));
 }
 function suggestionList(rows,locale){
  const lang=language(locale),text=copy[lang];if(!text||!Array.isArray(rows))return null;
  const clean=rows.slice(0,3).filter(row=>{try{const u=new URL(row.url,location.origin);return u.origin===location.origin&&/\/products\//.test(u.pathname)&&row.title&&Number.isSafeInteger(row.price)&&row.price>=0}catch(_){return false}});
  if(!clean.length)return null;
  const box=document.createElement('div');box.className='osn-plant-suggestions';const title=document.createElement('p');title.className='osn-plant-suggestions__title';title.textContent=text['cart.suggestions'];box.append(title);
  const list=document.createElement('ul');list.className='osn-plant-suggestions__list';
  clean.forEach(row=>{const li=document.createElement('li'),link=document.createElement('a');link.href=row.url;link.dataset.osnSuggestion=String(row.id);if(row.image){try{const u=new URL(row.image,location.origin);if(u.protocol==='https:'&&['cdn.shopify.com','oaksummitnursery.ca'].includes(u.hostname)){const image=document.createElement('img');image.src=u.href;image.alt='';image.width=64;image.height=64;image.loading='lazy';link.append(image)}}catch(_){}}
   const label=document.createElement('span'),name=document.createElement('span'),price=document.createElement('span');name.textContent=row.title;price.textContent=money(row.price,lang);label.append(name,price);link.append(label);li.append(link);list.append(li)});box.append(list);return box;
 }
 function renderSuggestions(container,rows,locale){
  const box=suggestionList(rows,locale);if(!box)return;
  container.querySelector('.osn-plant-suggestions')?.remove();container.querySelector(':scope > a')?.remove();container.append(box);
 }
 function mount(){document.querySelectorAll('[data-osn-plant-suggestions]').forEach(host=>{if(host.dataset.osnTermsMounted===host.dataset.osnPlantSuggestions)return;try{renderSuggestions(host,JSON.parse(host.dataset.osnPlantSuggestions),document.documentElement.lang);host.dataset.osnTermsMounted=host.dataset.osnPlantSuggestions}catch(_){}})}
 window.OsnPlantTerms={copy,language,isPlant,hasPlants,qualify,amounts,progress,minimum,renderSuggestions,money};
 document.addEventListener('DOMContentLoaded',mount);new MutationObserver(mount).observe(document.documentElement,{childList:true,subtree:true});
})();
/* OSN_TERMS_20261008_END */

function showOsnCartToast(productName) {
  var region = document.querySelector('[data-osn-cart-toast-region]');
  if (!region) {
    region = document.createElement('div');
    region.className = 'osn-cart-toast-region';
    region.setAttribute('data-osn-cart-toast-region', '');
    region.setAttribute('aria-live', 'polite');
    document.body.appendChild(region);
  }

  var cartText = window.OSN_THEME && window.OSN_THEME.locale && window.OSN_THEME.locale.cart || {};
  var toast = document.createElement('div');
  toast.className = 'osn-cart-toast';
  var heading = document.createElement('strong');
  var message = document.createElement('span');
  var link = document.createElement('a');
  var dismiss = document.createElement('button');
  heading.textContent = cartText.added || 'Added to cart';
  message.textContent = productName || cartText.itemAdded || 'Your item is in the cart.';
  link.href = window.OSN_THEME && window.OSN_THEME.cartUrl || '/cart';
  link.textContent = cartText.view || 'View cart';
  dismiss.type = 'button';
  dismiss.className = 'osn-cart-toast__dismiss';
  dismiss.textContent = '×';
  dismiss.setAttribute('aria-label', cartText.dismiss || 'Dismiss notification');
  toast.append(heading, message, link, dismiss);
  region.replaceChildren(toast);
  // Text-only readback: original Add, toast timing, links and navigation stay intact.
  if(window.OsnPlantTerms?.copy[window.OsnPlantTerms.language()]){
    var extra=document.createElement('span');extra.className='osn-cart-toast__terms';extra.hidden=true;link.before(extra);
    var base=window.OSN_THEME?.cartUrl||'/cart';
    Promise.all([fetch(base+'.js',{credentials:'same-origin',cache:'no-store'}).then(r=>{if(!r.ok)throw Error('Cart unavailable');return r.json()}),fetch(base+'?sections=main-cart-items',{credentials:'same-origin',cache:'no-store'}).then(r=>{if(!r.ok)throw Error('Cart unavailable');return r.json()})]).then(([cart,sections])=>{
      if(!toast.isConnected)return;
      var doc=new DOMParser().parseFromString(sections['main-cart-items'],'text/html');var rows=[...doc.querySelectorAll('[data-osn-panel-key]')];
      if(rows.length!==cart.items.length||cart.items.some(item=>{var row=rows.find(n=>n.dataset.osnPanelKey===item.key);return !row||Number(row.querySelector('input[name="updates[]"]')?.value)!==item.quantity}))return;
      var state=JSON.parse(doc.querySelector('[data-osn-plant-minimum-state]').textContent);
      extra.textContent=window.OsnPlantTerms.minimum(cart,state)||window.OsnPlantTerms.progress({...cart,plantMinimum:state},null,'toast.tier');extra.hidden=!extra.textContent;
    }).catch(()=>{});
  }

  var timer;
  function closeToast() {
    window.clearTimeout(timer);
    toast.remove();
  }
  function scheduleClose() {
    window.clearTimeout(timer);
    // Never remove a link while someone is reading or navigating the notice.
    if (!toast.matches(':hover') && !toast.contains(document.activeElement)) {
      timer = window.setTimeout(closeToast, 8000);
    }
  }
  toast.addEventListener('pointerenter', function () { window.clearTimeout(timer); });
  toast.addEventListener('focusin', function () { window.clearTimeout(timer); });
  toast.addEventListener('pointerleave', scheduleClose);
  toast.addEventListener('focusout', function () { window.setTimeout(scheduleClose, 0); });
  dismiss.addEventListener('click', closeToast);
  scheduleClose();

}

if (window.customElements) {
  window.customElements.whenDefined('cart-notification').then(function () {
    var CartNotification = window.customElements.get('cart-notification');
    if (!CartNotification || CartNotification.prototype.osnNonblockingOpen) return;

    CartNotification.prototype.open = function () {
      this.notification.classList.remove('animate', 'active');
      var productName = this.notification.querySelector('.cart-notification-product__name');
      showOsnCartToast(productName ? productName.textContent.trim() : '');
    };
    CartNotification.prototype.osnNonblockingOpen = true;
  });
}

// Cart hints reflect the server cart, not a remembered click or a stock count.
var refreshOsnCardCartState = (function () {
  var timer;
  var revision = 0;
  function render(items) {
    document.dispatchEvent(new CustomEvent('osn:cart-items', {detail: {items: items}}));
    var quantities = {};
    items.forEach(function (item) {
      quantities[String(item.product_id)] = (quantities[String(item.product_id)] || 0) + item.quantity;
    });
    document.querySelectorAll('.product-card [data-osn-card-save]').forEach(function (host) {
      var card = host.closest('.product-card');
      var commerce = card.querySelector('.product-card__commerce');
      if (!commerce) return;
      var hint = commerce.querySelector('[data-osn-in-cart]');
      var count = quantities[host.getAttribute('data-product-id')] || 0;
      if (!count) { if (hint) hint.remove(); return; }
      if (!hint) {
        hint = document.createElement('a');
        hint.className = 'product-card__cart-count';
        hint.setAttribute('data-osn-in-cart', '');
        var price = commerce.querySelector('.product-card__price');
        var priceRow = commerce.querySelector('.product-card__price-row');
        if (price && !priceRow) {
          priceRow = document.createElement('div');
          priceRow.className = 'product-card__price-row';
          price.before(priceRow);
          priceRow.appendChild(price);
        }
        (priceRow || commerce).appendChild(hint);
      }
      var cartText = window.OSN_THEME && window.OSN_THEME.locale && window.OSN_THEME.locale.cart || {};
      hint.href = window.OSN_THEME && window.OSN_THEME.cartUrl || '/cart';
      hint.textContent = (cartText.inCart || 'In cart: {{ count }}').replace(/{{\s*count\s*}}/g, String(count));
    });
  }
  return function () {
    if (!document.querySelector('.product-card [data-osn-card-save], [data-comparison-purchase]')) return;
    window.clearTimeout(timer);
    var requestRevision = ++revision;
    timer = window.setTimeout(function () {
      var url = (window.OSN_THEME && window.OSN_THEME.cartUrl || '/cart') + '.js';
      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
        .then(function (cart) {
          if (!Array.isArray(cart.items)) throw new Error('Cart unavailable');
          if (requestRevision === revision) render(cart.items);
        })
        .catch(function () {
          // Unknown is not an empty cart. Remove stale hints without changing it.
          if (requestRevision === revision) document.querySelectorAll('[data-osn-in-cart]').forEach(function (hint) { hint.remove(); });
        });
    }, 150);
  };
})();
document.addEventListener('DOMContentLoaded', refreshOsnCardCartState);
window.addEventListener('pageshow', refreshOsnCardCartState);
document.addEventListener('visibilitychange', function () {
  if (document.visibilityState === 'visible') refreshOsnCardCartState();
});

var osnPendingCardVariants = new Set();
function initOsnProductCardForms() {
  var pendingVariants = osnPendingCardVariants;
  document.querySelectorAll('form.product-card__form').forEach(function (form) {
    if (form.dataset.osnAjaxCart === 'true') return;
    form.dataset.osnAjaxCart = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      var variant = form.querySelector('[name="id"]').value;
      if (pendingVariants.has(variant)) return;

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function') {
        form.submit();
        return;
      }

      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      pendingVariants.add(variant);
      var cartText = window.OSN_THEME && window.OSN_THEME.locale && window.OSN_THEME.locale.cart || {};
      var label = button.querySelector('span');
      var originalLabel = label ? label.textContent : '';
      if (label) label.textContent = cartText.adding || 'Adding…';
      var feedback = form.querySelector('[data-osn-cart-error]');
      if (!feedback) {
        feedback = document.createElement('div');
        feedback.className = 'osn-cart-error';
        feedback.setAttribute('data-osn-cart-error', '');
        feedback.setAttribute('role', 'alert');
        form.appendChild(feedback);
      }
      feedback.replaceChildren();
      feedback.hidden = true;
      var controller = new AbortController();
      var timeout;
      var added = false;
      function showFailure(message) {
        var copy = document.createElement('span');
        copy.textContent = message;
        var link = document.createElement('a');
        link.href = window.OSN_THEME && window.OSN_THEME.cartUrl || '/cart';
        link.textContent = cartText.view || 'View cart';
        feedback.replaceChildren(copy, link);
        feedback.hidden = false;
      }
      // Promise boundary also catches section/config setup failures.
      Promise.resolve().then(function () {
      var formData = new FormData(form);
      formData.append('sections', cart.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      config.signal = controller.signal;
      timeout = window.setTimeout(function () { controller.abort(); }, 15000);

      return fetch(window.routes.cart_add_url, config)
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok || body.status) {
              // Shopify may partially add on an inventory error. Never retry automatically.
              var error = new Error('Cart response rejected');
              error.inventory = response.status === 422;
              throw error;
            }
            return body;
          });
        })
        .then(function (response) {
          added = true;
          if (!response.sections || Object.keys(response.sections).some(function (key) { return response.sections[key] === null; })) {
            throw new Error('Cart added but section refresh failed');
          }
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
      })
        .catch(function (error) {
          if (added) {
            showFailure(cartText.refreshError || 'Added to your cart, but the cart display could not refresh. View your cart before adding again.');
          } else if (error.inventory) {
            showFailure(cartText.stockError || 'This quantity may no longer be available. Check your cart before trying again.');
          } else {
            showFailure(cartText.addError || 'We could not confirm the addition. Check your cart before trying again.');
          }
        })
        .finally(function () {
          window.clearTimeout(timeout);
          pendingVariants.delete(variant);
          if (label) label.textContent = originalLabel;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
          refreshOsnCardCartState();
        });
    });
  });
}
document.addEventListener('DOMContentLoaded', initOsnProductCardForms);
document.addEventListener('osn:product-cards-added', initOsnProductCardForms);

// Collection reminders use the existing wishlist reminder API without leaving
// the collection. The product link remains a no-JavaScript fallback.
var osnReminderDialog;
var osnReminderOpener;
var osnReminderBodyOverflow;
function closeOsnReminderDialog() {
  if (!osnReminderDialog || !osnReminderDialog.open) return;
  osnReminderDialog.close();
  document.body.style.overflow = osnReminderBodyOverflow || '';
  if (osnReminderOpener && document.contains(osnReminderOpener)) {
    osnReminderOpener.focus({ preventScroll: true });
  }
}
function ensureOsnReminderDialog() {
  if (osnReminderDialog) return osnReminderDialog;
  var dialog = document.createElement('dialog');
  dialog.className = 'osn-reminder-dialog';
  dialog.setAttribute('aria-labelledby', 'OsnReminderDialogHeading');
  dialog.innerHTML = '<div class="osn-reminder-dialog__bar"><span data-osn-reminder-product></span><button type="button" data-osn-reminder-close></button></div><div class="osn-reminder-dialog__content" data-osn-product-actions><p class="osn-stock-reminder__heading" id="OsnReminderDialogHeading" data-osn-reminder-heading></p><p class="osn-stock-reminder__copy" data-osn-reminder-copy></p><form class="osn-stock-reminder__form" data-osn-stock-form><label class="visually-hidden" for="OsnReminderDialogEmail" data-osn-reminder-email-label></label><input id="OsnReminderDialogEmail" class="osn-stock-reminder__input" type="email" name="email" autocomplete="email" required><button type="submit" class="osn-stock-reminder__submit" data-osn-reminder-submit></button></form><p class="osn-stock-reminder__note" data-osn-reminder-note></p><p class="osn-stock-reminder__status" data-osn-stock-status role="status"></p></div>';
  dialog.querySelector('[data-osn-reminder-close]').addEventListener('click', closeOsnReminderDialog);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); closeOsnReminderDialog(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) closeOsnReminderDialog(); });
  document.body.appendChild(dialog);
  osnReminderDialog = dialog;
  return dialog;
}
function openOsnReminderDialog(link) {
  var dialog = ensureOsnReminderDialog();
  if (!dialog || typeof dialog.showModal !== 'function') return false;
  var card = link.closest('.product-card');
  var source = card && card.querySelector('[data-osn-card-save]');
  if (!source) return false;
  var context = dialog.querySelector('[data-osn-product-actions]');
  ['product-id', 'variant-id', 'handle', 'title', 'variant-title', 'url', 'image', 'available', 'price-cents', 'price-text'].forEach(function (name) {
    var value = source.getAttribute('data-' + name);
    if (value === null) context.removeAttribute('data-' + name);
    else context.setAttribute('data-' + name, value);
  });
  dialog.querySelector('[data-osn-reminder-product]').textContent = source.getAttribute('data-title') || '';
  dialog.querySelector('[data-osn-reminder-heading]').textContent = link.getAttribute('data-osn-reminder-heading') || 'Notify me when back in stock';
  dialog.querySelector('[data-osn-reminder-copy]').textContent = link.getAttribute('data-osn-reminder-copy') || '';
  var emailLabel = link.getAttribute('data-osn-reminder-email') || 'Email address';
  var email = dialog.querySelector('[type="email"]');
  dialog.querySelector('[data-osn-reminder-email-label]').textContent = emailLabel;
  email.placeholder = emailLabel;
  email.value = link.getAttribute('data-osn-customer-email') || '';
  dialog.querySelector('[data-osn-reminder-submit]').textContent = link.getAttribute('data-osn-reminder-submit') || 'Notify me';
  dialog.querySelector('[data-osn-reminder-note]').textContent = link.getAttribute('data-osn-reminder-note') || '';
  var status = dialog.querySelector('[data-osn-stock-status]');
  status.textContent = '';
  status.className = 'osn-stock-reminder__status';
  dialog.querySelector('[data-osn-reminder-close]').textContent = ((window.OSN_THEME || {}).locale || {}).cartPanel && window.OSN_THEME.locale.cartPanel.close || 'Close';
  osnReminderOpener = link;
  osnReminderBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  dialog.showModal();
  window.requestAnimationFrame(function () { email.focus(); });
  return true;
}
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-osn-reminder-open]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (openOsnReminderDialog(link)) event.preventDefault();
});

document.addEventListener('DOMContentLoaded', function () {
  var catalogText = window.OSN_THEME && window.OSN_THEME.locale && window.OSN_THEME.locale.catalogSearch || {};
  var catalogs = [
    {
      root: '.osn-seed-catalog',
      layout: '.osn-seed-catalog__jump',
      topId: 'osn-seed-catalog-top',
      label: catalogText.label,
      placeholder: catalogText.seedSections,
      empty: catalogText.emptySeeds
    },
    {
      root: '.osn-seed-term-catalog',
      layout: '.osn-seed-term-catalog__jump',
      topId: 'osn-seed-term-catalog-top',
      label: catalogText.label,
      placeholder: catalogText.seedCollection,
      empty: catalogText.emptySeeds
    },
    {
      root: '.osn-tomato-catalog',
      layout: '.osn-tomato-catalog__jump',
      topId: 'osn-tomato-catalog-top',
      label: catalogText.label,
      placeholder: catalogText.tomatoes,
      empty: catalogText.emptyTomatoes
    },
    {
      root: '.osn-pepper-catalog',
      layout: '.osn-pepper-catalog__jump',
      topId: 'osn-pepper-catalog-top',
      label: catalogText.label,
      placeholder: catalogText.peppers,
      empty: catalogText.emptyPeppers
    }
  ];

  catalogs.forEach(function (config) {
    document.querySelectorAll(config.root).forEach(function (root, index) {
      var jump = root.querySelector(config.layout);
      var sections = Array.prototype.slice.call(root.querySelectorAll('.osn-category'));
      if (!jump || sections.length === 0 || root.querySelector('[data-osn-catalog-search]')) return;

      var searchId = config.topId + '-search-' + index;
      var search = document.createElement('div');
      search.className = 'osn-catalog-search';
      search.setAttribute('data-osn-catalog-search', '');
      search.innerHTML = '<label for="' + searchId + '">' + config.label + '</label><input id="' + searchId + '" type="search" autocomplete="off" placeholder="' + config.placeholder + '"><p class="osn-catalog-search__hint" aria-live="polite">' + catalogText.allSections + '</p>';
      jump.insertAdjacentElement('afterbegin', search);

      var empty = document.createElement('div');
      empty.className = 'osn-search-empty';
      empty.textContent = config.empty;
      sections[sections.length - 1].insertAdjacentElement('afterend', empty);

      var top = document.createElement('a');
      top.className = 'osn-mobile-top';
      top.href = '#' + config.topId;
      top.textContent = catalogText.top;
      root.appendChild(top);

      root.querySelectorAll('.osn-category__footer a').forEach(function (link) {
        link.classList.add('osn-category__back');
        link.textContent = catalogText.top;
      });

      var input = search.querySelector('input');
      var hint = search.querySelector('.osn-catalog-search__hint');
      var originalCounts = new Map();
      sections.forEach(function (section) {
        var count = section.querySelector('.osn-category__count');
        if (count) originalCounts.set(section, count.textContent);
      });

      function normalize(value) {
        return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      }

      function sectionCards(section) {
        return Array.prototype.slice.call(section.querySelectorAll('.grid__item'));
      }

      function filterCatalog() {
        var query = normalize(input.value);
        var totalVisible = 0;

        sections.forEach(function (section) {
          var visibleInSection = 0;
          sectionCards(section).forEach(function (card) {
            var match = !query || normalize(card.textContent).indexOf(query) !== -1;
            card.hidden = !match;
            if (match) visibleInSection += 1;
          });

          var showSection = !query || visibleInSection > 0;
          section.classList.toggle('is-hidden-by-search', !showSection);

          var count = section.querySelector('.osn-category__count');
          if (count) {
            count.textContent = query
              ? (visibleInSection === 1 ? catalogText.shownOne : catalogText.shownMany)
                  .replace(/{{\s*count\s*}}/g, String(visibleInSection))
              : originalCounts.get(section);
          }

          var link = jump.querySelector('a[href="#' + section.id + '"]');
          if (link) link.hidden = !showSection;
          totalVisible += visibleInSection;
        });

        hint.textContent = query
          ? (totalVisible === 1 ? catalogText.shownOne : catalogText.shownMany).replace(/{{\s*count\s*}}/g, String(totalVisible))
          : catalogText.allSections;
        empty.classList.toggle('is-visible', Boolean(query) && totalVisible === 0);
      }

      input.addEventListener('input', filterCatalog);
      // Per-history-entry state keeps Back/Forward useful without SEO query
      // parameters or a persistent filter unexpectedly applied to a new visit.
      var stateKey = window.location.pathname + ':' + searchId;
      var saveTimer;
      function saveSearch(includePosition) {
        window.clearTimeout(saveTimer);
        try {
          var state = window.history.state;
          if (state !== null && (typeof state !== 'object' || Array.isArray(state))) return;
          var next = Object.assign({}, state || {});
          next.osnCatalogSearch = Object.assign({}, next.osnCatalogSearch || {});
          next.osnCatalogSearch[stateKey] = input.value;
          if (includePosition !== false) {
            next.osnCatalogScroll = Object.assign({}, next.osnCatalogScroll || {});
            next.osnCatalogScroll[stateKey] = window.scrollY;
          }
          window.history.replaceState(next, '', window.location.href);
        } catch (_error) { /* Storage restrictions must not prevent shopping. */ }
      }
      function restoreSearch() {
        try {
          var saved = (window.history.state || {}).osnCatalogSearch || {};
          if (typeof saved[stateKey] === 'string') input.value = saved[stateKey];
        } catch (_error) { /* Keep the ordinary unfiltered page. */ }
        filterCatalog();
      }
      function restorePosition(event) {
        // WebKit can restore against the short, not-yet-filtered layout.
        // Preserve native BFCache behavior; correct only a rebuilt return page.
        if (event.persisted) return;
        var navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
        if (!navigation || ['back_forward', 'reload'].indexOf(navigation.type) === -1) return;
        var target = ((window.history.state || {}).osnCatalogScroll || {})[stateKey];
        if (typeof target !== 'number' || !Number.isFinite(target)) return;
        var interrupted = false;
        function cancel() { interrupted = true; }
        ['wheel', 'touchstart', 'keydown'].forEach(function (name) { window.addEventListener(name, cancel, { passive: true }); });
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            ['wheel', 'touchstart', 'keydown'].forEach(function (name) { window.removeEventListener(name, cancel); });
            if (!interrupted && Math.abs(window.scrollY - target) > 100) {
              window.scrollTo({ top: target, left: window.scrollX, behavior: 'instant' });
            }
          });
        });
      }
      input.addEventListener('input', function () {
        window.clearTimeout(saveTimer);
        saveTimer = window.setTimeout(saveSearch, 250);
      });
      document.addEventListener('click', function (event) {
        if (event.target.closest('a[href]')) saveSearch();
      });
      window.addEventListener('scroll', function () {
        if (document.visibilityState === 'hidden') return;
        window.clearTimeout(saveTimer);
        saveTimer = window.setTimeout(saveSearch, 500);
      }, { passive: true });
      // WebKit can reset scrollY before pagehide. Preserve the position saved
      // during scrolling/link activation rather than overwriting it with zero.
      window.addEventListener('pagehide', function () { saveSearch(false); });
      window.addEventListener('pageshow', function (event) { restoreSearch(); restorePosition(event); });
      window.addEventListener('popstate', restoreSearch);
      restoreSearch();
      filterCatalog();
    });
  });
});

/* OSN_CART_PANEL_GENERATED_START */
/* Display existing native order tiers; never create/apply a discount. */
(function(){
 const tiers=[{at:10000,percent:5,title:'5% Discount Over $100'},{at:25000,percent:10,title:'10% Discount Over $250'},{at:50000,percent:15,title:'15% Discount Over $500'}];
 const copy={en:{add:'Spend {amount} more for {percent}% off your order',earned:'{percent}% order discount applied',next:'Next order tier: {percent}% at {amount}'},fr:{add:'Ajoutez encore {amount} à votre commande pour une réduction de {percent} %',earned:'Réduction de {percent} % appliquée à la commande',next:'Prochain palier : {percent} % à {amount}'},es:{add:'Añada {amount} más al pedido para obtener un {percent} % de descuento',earned:'Descuento del {percent} % aplicado al pedido',next:'Siguiente nivel: {percent} % a partir de {amount}'}};
 window.OsnCartTierProgress=function(cart,locale){
  const terms=window.OsnPlantTerms,lang=terms?.language(locale),qualified=terms?.copy[lang];
  if(qualified){
    if(cart?.currency!=='CAD'||!terms.hasPlants(cart))return '';
    const titles=cart.items.flatMap(i=>i.line_level_discount_allocations||[]).filter(a=>a.amount>0).map(a=>a.discount_application?.title);
    const applied=tiers.filter(t=>titles.includes(t.title)||(cart.cart_level_discount_applications||[]).some(a=>a.title===t.title&&a.total_allocated_amount>0)).at(-1);
    return applied?qualified['cart.tier.applied'].replace('{percent}',applied.percent):terms.progress(cart,locale,'cart.tier.add');
  }

  if(!cart||cart.currency!=='CAD'||!Number.isSafeInteger(cart.original_total_price)||!cart.items?.length)return '';
  const isPlant=i=>i.kind==='plant'||/^(trees?|shrubs?|plants?|plant collection)$/i.test(i.product_type||'');
  if(!cart.items.some(isPlant))return '';
  const language=(locale||'en').split('-')[0],text=copy[language];if(!text)return '';
  const money=n=>new Intl.NumberFormat(language+'-CA',{style:'currency',currency:'CAD',currencyDisplay:'narrowSymbol'}).format(n/100);
  const allocations=cart.items.flatMap(i=>i.line_level_discount_allocations||[]).filter(a=>a.amount>0).map(a=>a.discount_application?.title);
  const confirmed=tiers.filter(t=>allocations.includes(t.title)||(cart.cart_level_discount_applications||[]).some(a=>a.title===t.title&&a.total_allocated_amount>0)).at(-1);
  if(confirmed)return text.earned.replace('{percent}',confirmed.percent);
  // Native minimum: merchandise after product discounts, before order discounts.
  if(!Number.isSafeInteger(cart.total_price)||cart.total_price<0)return '';
  const orderAmounts=(cart.cart_level_discount_applications||[]).map(a=>a.total_allocated_amount);
  if(orderAmounts.some(n=>!Number.isSafeInteger(n)||n<0))return '';
  const basis=cart.total_price+orderAmounts.reduce((sum,n)=>sum+n,0);
  const next=tiers.find(t=>t.at>basis);if(!next)return '';
  const pattern=text.add;
  return pattern.replace('{amount}',money(Math.max(0,next.at-basis))).replace('{percent}',next.percent);
 };
})();

/* Shared estimator component. The caller owns authoritative cart reads and native
   Shopify rates; no customer data is sent to analytics. */
(function () {
  'use strict';
  function province(postal) {
    const p=postal.toUpperCase().replace(/\s/g,'');
    if(!/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(p)) return '';
    if(p[0]==='X')return /^X0[ABC]/.test(p)?'Nunavut':'Northwest Territories';
    return {A:'Newfoundland and Labrador',B:'Nova Scotia',C:'Prince Edward Island',E:'New Brunswick',G:'Quebec',H:'Quebec',J:'Quebec',K:'Ontario',L:'Ontario',M:'Ontario',N:'Ontario',P:'Ontario',R:'Manitoba',S:'Saskatchewan',T:'Alberta',V:'British Columbia',Y:'Yukon'}[p[0]]||'';
  }
  // Exact native profile/component capture; generated from bc_shipping_restrictions.json.
  const bcRestrictedVariants=new Set([37219386818718,41212124856478,41212161097886,41569396523166,41569396555934,42137745850526,42137761317022,42137770459294,42137774915742,42137779699870,42137855262878,42137866240158,42137873350814,42137921749150,42137941278878,42190884503710,42190884536478,42190884569246,42211756638366,42211790454942,42211790487710,42211821322398,42211833708702,42211857694878,42213712298142,42213941903518,42213977096350,42214496993438,42214521831582,42443695816862,42443695849630,42443695882398,42443695915166,42443695947934,42443695980702,42443696013470,42443696046238,42443696079006,42443696111774,42443696144542,42443696177310,42443696210078,42443696242846,42443696275614,42443696308382,42443696341150,42443696373918,42443696406686,42443696439454,42443696472222,42443696504990,42443696537758,42443696570526,42443696603294,42443696636062,42443696668830,42443696701598,42443696734366,43052242731166,43052242763934,43052261867678,43052493897886,43052506120350,43052533055646,43052542787742,43052555403422,43052619989150,43052627919006,43052627951774,43052644499614,43052646138014,43052658720926,43052661932190,43052665798814,43052665831582,43052668256414,43052668289182,43052672057502,43052672090270,43068901589150,43068915089566,43068915122334,43068915482782,43068931211422,43068931834014,43068931866782,43068933374110,43068935307422,43068935340190,43068938879134,43068940943518,43069001203870,43069001236638,43069003694238,43069026074782,43069026107550,43069031710878,43069034528926,43069034922142,43069047111838,43223520575646,43223520641182,44134863470750,44234294427806,44277188100254,44277190394014,44277202550942,44277206483102,44277465448606,44277468758174,44277473837214,44278481715358,44278485942430,44278487744670,44294366199966,44294371082398,44294389301406,44294396215454,44294414893214,44297171697822,44297192079518,44297203450014,44297222455454,44297251913886,44297301819550,44297308995742,44362178527390,44362196910238,44362514038942,44452442407070,44596591526046,44596591558814,44600726847646,44631287988382,44631817683102,44632956928158,44632976490654,44634796818590,44636103803038,44636142731422,44636522512542,44637152673950,44637235183774,44637235216542,44637264216222,44637503193246,44637516103838,44643547349150,44643547381918,44643547414686,44647969128606,44647969161374,44648063795358,44648113832094,44648125661342,45990670794910,45993628106910,45993650028702,45995801510046,45995876515998,45995888935070,45996574703774,45996708233374,45998159364254,46000344432798,46000467148958,46001963237534,46001963597982,46001963892894,46001981915294,46001983586462,46002013765790,46002018386078,46263832674462,46264018829470,46264205574302,46264206557342,46264226775198,46264228675742,46264345395358,46264347656350,46264347951262,46264348999838,46264350277790,46264350638238,46264351654046,46264352669854,46264353423518,46264353652894,46264355651742,46264356733086,46264356896926,46264357814430,46264358699166,46264361386142,46264362238110,46264362434718,46264363516062,46264364531870,46264487772318,46264490229918,46264490983582,46264492589214,46264494686366,46264494915742,46264496750750,46264498618526,46264499601566,46264499929246,46264500912286,46264502091934,46264502321310,46264557863070,46264558747806,46264558944414,46264559141022,46264559960222,46264562090142,46264563368094,46264564547742,46264565268638,46264565563550,46264567005342,46264568676510,46264568905886,46264571166878,46264571232414,46264571330718,46264571363486,46264588861598,46264589090974,46264589877406,46264590663838,46264591679646,46264592695454,46264593023134,46264593940638,46264594137246,46264594956446,46264596299934,46264600428702,46264600625310,46264625594526,46264626741406,46264627658910,46264627921054,46264628936862,46264629952670,46264632246430,46264633196702,46264635588766,46264636539038,46264636768414,46264638177438,46264639127710,46264640274590,46264641618078,46264642306206,46264643813534,46264645091486,46264686968990,46264688509086,46264688738462,46264689557662,46264690213022,46264691687582,46264692834462,46264693784734,46264698175646,46264703058078,46264707121310,46264707350686,46264708104350,46264708858014,46264709808286,46264711053470,46264711970974,46264712921246,46264713740446,46264713937054,46264714657950,46264716787870,46264716984478,46264718295198,46264718557342,46264732614814,46264733597854,46264735367326,46264736546974,46264738480286,46264739496094,46264741200030,46264741429406,46264742281374,46264742477982,46264743461022,46264744607902,46264745754782,46264746803358,46264747065502,46264748507294,46264749588638,46264749752478,46264749949086,46264750145694,46264750342302,46264751095966,46264792219806,46264792383646,46264792580254,46264792809630,46264793006238,46264793170078,46264793333918,46264794742942,46264796807326,46264798412958,46264799690910,46264800772254,46264801493150,46264802410654,46264803197086,46264805195934,46264807522462,46264808931486,46264810012830,46264811192478,46264813387934,46264814305438,46264815354014,46264815550622,46264843960478,46264844157086,46264845598878,46264846680222,46264846942366,46264847761566,46264848777374,46264849039518,46264849268894,46264850251934,46264851824798,46264852643998,46264854773918,46264855691422,46264856641694,46264858804382,46264860442782,46264862212254,46264909987998,46264916803742,46264918704286,46264918900894,46265468780702,46265739444382,46265739477150,46265739509918,46265747734686,46265747767454,46265747800222,46265747832990,46265747931294,46265749733534,46265749799070,46265749831838,46265749897374,46265749962910,46265750126750,46265750159518,46265750192286,46265750225054,46265750257822,46265750290590,46265750388894,46265750421662,46265750454430,46265750487198,46265750552734,46265750585502,46265750618270,46265791185054,46265791217822,46265791283358,46265810813086,46265811730590,46265811796126,46265812222110,46265822806174,46265822871710,46265822937246,46265823002782,46265823101086,46265823166622,46265823232158,46265823297694,46266540949662,46266585088158,46266585153694,46266585251998,46266585383070,46266585448606,46266614218910,46266614382750,46267765522590,46267766505630,46267766538398,46267766669470,46267766702238,46267766767774,46267769192606,46267769225374,46325291614366,46325291647134,46325291679902,46325291712670,46325291745438,46325291778206,46325291810974,46325291843742,46325291876510,46325291909278,46325291942046,46325291974814,46325292007582,46325292040350,46325292073118,46325292105886,46325292138654,46325292171422,46325292204190,46325292236958,46325292269726,46325292302494,46325292335262,46325292368030,46325292400798,46325292433566,46325292466334,46325292499102,46325292728478,46325292826782,46325292892318,46325292957854,46325293023390,46325293088926,46325293121694,46325293416606,46325293449374,46325293482142,46325293514910,46325293547678,46325293580446,46325293613214,46325293645982,46325293678750,46325293711518,46325293744286,46325293777054,46325293809822,48212268875934,48278437331102,48278442541214,48278449127582,48278450045086,48278450667678,48278451552414,48278452961438,48278452994206,48278456271006,48278457221278,48278459318430,48278459875486,48278459908254,48278462234782,48278468133022,48278468395166,48278469378206,48278470721694,48278477471902,48278482878622,48278483665054,48278486974622,48278489399454,48278489825438,48278492512414,48278493102238,48278494150814,48278504898718,48278505521310,48278507454622,48278509322398,48278509617310,48278510338206,48278510960798,48278511681694,48278512042142,48278516301982,48278516859038,48278516891806,48278516924574,48278518464670,48278519971998,48278521020574,48278521839774,48278521872542,48278524428446,48278525378718,48278526197918,48278526754974,48278528950430,48278528983198,48278531375262,48278533898398,48278535110814,48278537109662,48278537863326,48278540157086,48278540189854,48278541074590,48278543433886,48278544482462,48278544515230,48278546579614,48278547398814,48278548152478,48278550511774,48278551756958,48278552936606,48278554542238,48278555164830,48278556246174,48278557229214,48278558376094,48278559096990,48278697148574,48278700982430,48278701047966,48278701605022,48278701670558,48278701703326,48278732669086,48278733291678,48278733553822,48278734045342,48278736994462,48278737846430,48278737944734,48278800138398,48278801514654,48278801547422,48278802137246,48278802202782,48278802301086,48278802727070,48278802759838,48278802792606,48278802825374,48278802989214,48278803021982,48278803415198,48278804005022,48278804037790,48278804332702,48278804562078,48278804988062,48278805708958,48278805938334,48278806003870,48278806069406,48278806593694,48278806626462,48278807019678,48278807052446,48278807085214,48278807183518,48278807249054,48278807281822,48278807609502,48278807675038,48278807740574,48278807773342,48278808133790,48278808527006,48278808625310,48278809444510,48278809641118,48278809804958,48278810034334,48278811082910,48285342072990,48285342335134,48285342531742,48285343056030,48285343252638,48285343285406,48285343318174,48285343482014,48285343580318,48285343613086,48285343645854,48285345939614,48285346070686,48285346136222,48285346431134,48285348855966,48285350494366,48285351182494,48285351248030,48285352329374,48285355278494,48285355966622,48285355999390,48287216304286,48287216337054,48287216369822,48287216402590,48287216435358,48287216468126,48287216500894,48287216533662,48287216566430,48287216599198,48287216894110,48288538886302,48291129589918,48291129655454,48291129688222,48291129720990,48291129786526,48291130310814,48291130376350,50523725136030,50523727724702,50523728445598]);
  const bcShippingHelpLabels={"en":"Shipping to British Columbia","fr":"Expédition vers la Colombie-Britannique","es":"Envíos a Columbia Británica"};
  window.OsnShippingEstimate=function(options){
    const t=options.text, details=document.createElement('details');details.className='osn-shipping-estimate';
    const node=(tag,text)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;return n};
    const title=node('summary',t.title);const form=node('form');const label=node('label',t.postal);const input=node('input');
    const id='osn-shipping-postal-'+Math.random().toString(36).slice(2);input.id=id;label.htmlFor=id;input.autocomplete='shipping postal-code';input.autocapitalize='characters';input.spellcheck=false;input.placeholder='R7A 5Y2';input.maxLength=12;
    const row=node('div');row.className='osn-shipping-estimate__row';const submit=node('button',t.button);submit.type='submit';row.append(input,submit);
    const money=value=>options.money?options.money(value):new Intl.NumberFormat(options.locale,{style:'currency',currency:cart.currency,currencyDisplay:cart.currency==='CAD'?'narrowSymbol':'symbol'}).format(value);
    const output=node('div');output.className='osn-shipping-estimate__result';output.setAttribute('role','status');output.setAttribute('aria-live','polite');output.hidden=true;
    const note=node('p',t.final);note.className='osn-shipping-estimate__note';
    form.append(label,row,output,note);details.append(title,form);
    const warning=node('div');warning.className='osn-bc-shipping-warning';warning.setAttribute('role','status');warning.setAttribute('aria-live','polite');warning.hidden=true;
    let cart=null,generation=0,controller=null,submitted=false;
    // Only this explicitly entered Canadian SHIPPING postal code determines destination.
    // Saved postal values, markets, IP and billing addresses never establish BC.
    function updateWarning(){
      const restricted=(cart?.items||[]).filter(item=>Number(item.quantity)>0&&bcRestrictedVariants.has(Number(item.variant_id||item.id)));
      warning.hidden=province(input.value)!=='British Columbia'||!restricted.length;
      warning.replaceChildren();if(warning.hidden)return;
      const qualified=window.OsnPlantTerms?.copy[window.OsnPlantTerms.language(options.locale)];if(qualified)warning.append(node('strong',qualified['cart.bc.title']));
      warning.append(node('p',t.bcRestricted));const list=node('ul');
      restricted.forEach(item=>{
        const entry=node('li');entry.append(node('span',item.product_title||item.title));
        if(options.remove&&item.key){const button=node('button',t.remove);button.type='button';
          button.setAttribute('aria-label',t.remove+' '+(item.product_title||item.title));
          button.addEventListener('click',async()=>{button.disabled=true;try{await options.remove(item.key)}catch(_){button.disabled=false;message(t.unavailable)}});entry.append(button)}
        list.append(entry);
      });warning.append(list);const help=node('a',bcShippingHelpLabels[(options.locale||document.documentElement.lang||'en').split('-')[0]]||bcShippingHelpLabels.en);help.href=(window.Shopify?.routes?.root||'/')+'pages/shipping#shipping-to-british-columbia';warning.append(help);
    }
    function invalidate(){updateWarning();generation++;controller?.abort();controller=null;output.replaceChildren();output.hidden=true;submit.disabled=false;submit.textContent=t.button;title.textContent=t.title}
    function message(value){output.replaceChildren(node('p',value));output.hidden=false}
    function empty(){invalidate();details.hidden=true;submit.disabled=true}
    async function estimate(keepClosed=false){
      invalidate();if(!cart?.items?.length){empty();return}
      const region=province(input.value);if(!region){message(t.invalid);return}
      submitted=true;if(!keepClosed)details.open=true;const current=generation;controller=new AbortController();const signal=controller.signal;
      message(t.loading);submit.disabled=true;
      try{
        const result=await options.quote({country:'Canada',province:region,zip:input.value.toUpperCase().replace(/\s/g,'')},signal);
        if(current!==generation)return;
        const rates=result?.shipping_rates;
        if(!Array.isArray(rates)||!rates.length||rates.some(r=>typeof r.price!=='string'||!/^\d+(\.\d{1,2})?$/.test(r.price)||typeof r.name!=='string'||(r.currency&&r.currency!==cart.currency)))throw Error('Unavailable');
        output.replaceChildren();output.hidden=false;
        output.append(node('p',t.destination.replace('{province}',region)));
        rates.slice().sort((a,b)=>Number(a.price)-Number(b.price)).forEach(r=>{const item=node('p');item.className='osn-shipping-estimate__rate';const amount=node('strong',money(Number(r.price)));item.append(amount,node('span',r.presentment_name||r.name));output.append(item)});
        if(Number.isSafeInteger(cart.total_price)&&cart.total_price>=0){const total=node('p');total.className='osn-shipping-estimate__total';total.append(node('span',t.total),node('strong',money(cart.total_price/100+Math.min(...rates.map(r=>Number(r.price))))));output.append(total)}
        submit.textContent=t.update;title.textContent=t.title+' · '+money(Math.min(...rates.map(r=>Number(r.price))))+' · '+region;
      }catch(_){if(current===generation)message(t.unavailable)}finally{if(current===generation){controller=null;submit.disabled=false}}
    }
    input.addEventListener('input',()=>{input.value=input.value.toUpperCase();invalidate()});
    form.addEventListener('submit',e=>{e.preventDefault();estimate()});
    return {element:details,warning,setCart(value){const previous=cart?JSON.stringify([cart.currency,cart.items.map(i=>[i.key,i.quantity,i.final_line_price])]):'';cart=value;const next=JSON.stringify([cart?.currency,cart?.items?.map(i=>[i.key,i.quantity,i.final_line_price])]);if(!cart?.items?.length){empty();return}details.hidden=false;if(previous!==next){invalidate();if(input.value)estimate(!details.open)}},dispose:invalidate};
  };
  // Use Shopify's existing cart session and configured shipping rules.
  // Merely constructing this adapter makes no request.
  window.OsnShippingEstimate.nativeQuote=async function(address,signal,root){
    const base=new URL(root||window.Shopify?.routes?.root||'/',location.origin);
    if(base.origin!==location.origin||!base.pathname.endsWith('/'))throw Error('Invalid storefront root');
    const parameters=new URLSearchParams();
    Object.entries(address).forEach(([key,value])=>parameters.set('shipping_address['+key+']',value));
    const controller=new AbortController();const abort=()=>controller.abort();
    if(signal?.aborted)throw Error('Aborted');signal?.addEventListener('abort',abort,{once:true});
    const timeout=setTimeout(abort,20000);
    try{
      const prepared=await fetch(new URL('cart/prepare_shipping_rates.json?'+parameters,base),{method:'POST',credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if(!prepared.ok)throw Error('Unavailable');
      for(let attempt=0;attempt<10;attempt++){
        const response=await fetch(new URL('cart/async_shipping_rates.json?'+parameters,base),{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if(!response.ok)throw Error('Unavailable');
        const result=await response.json();if(result!==null)return result;
        await new Promise((resolve,reject)=>{let timer;const stop=()=>{clearTimeout(timer);controller.signal.removeEventListener('abort',stop);reject(Error('Aborted'))};timer=setTimeout(()=>{controller.signal.removeEventListener('abort',stop);resolve()},1000);controller.signal.addEventListener('abort',stop,{once:true});if(controller.signal.aborted)stop()});
      }
      throw Error('Unavailable');
    }finally{clearTimeout(timeout);signal?.removeEventListener('abort',abort)}
  };
  window.OsnShippingEstimate.copy=function(source){const text={remove:source.remove};['title','postal','button','final','empty','invalid','loading','unavailable','destination','total','update','bcRestricted'].forEach(key=>text[key]=source['estimate'+key[0].toUpperCase()+key.slice(1)]);return text};
  document.addEventListener('DOMContentLoaded',()=>{
    let mounted=null,widget=null,controller=null;
    function mount(){
      const target=document.querySelector('[data-osn-shipping-estimate]');
      if(!target||target===mounted||!window.OSN_THEME?.locale?.cartPanel)return;
      controller?.abort();widget?.dispose();mounted=target;controller=new AbortController();
      const active=controller;widget=window.OsnShippingEstimate({text:window.OsnShippingEstimate.copy(window.OSN_THEME.locale.cartPanel),locale:document.documentElement.lang,quote:(address,signal)=>window.OsnShippingEstimate.nativeQuote(address,signal),remove:async key=>{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});if(!response.ok)throw Error('Unavailable');location.reload()}});
      const current=widget;target.replaceChildren(widget.warning,widget.element);widget.element.hidden=true;
      fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store',signal:active.signal}).then(r=>{if(!r.ok)throw Error('Unavailable');return r.json()}).then(cart=>{if(target.isConnected&&current===widget){current.setCart(cart);const tier=document.querySelector('[data-osn-cart-tier]');if(tier){const qualified=window.OsnPlantTerms?.qualify(cart,document);tier.textContent=qualified?window.OsnCartTierProgress?.(qualified,document.documentElement.lang)||'':'';tier.hidden=!tier.textContent}}}).catch(()=>{current.dispose();current.element.hidden=true});
    }
    mount();const observer=new MutationObserver(mount);observer.observe(document.body,{childList:true,subtree:true});
  });
  window.OsnShippingEstimate.province=province;
})();

/* F3c component. No provider, analytics transport or automatic opening is wired here.
   Adapter contract: read(signal), change(lineKey, absoluteQuantity, signal).
   Every response is a complete authoritative cart, never a locally inferred total. */
(function () {
  'use strict';
  window.OsnCartPanel = function (options) {
    const text = options.text;
    const dialog = document.createElement('dialog');
    dialog.className = 'osn-cart-panel';
    dialog.setAttribute('aria-labelledby', 'osn-cart-panel-title');
    const element = (tag, className, value) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    };
    const button = (label, handler, className) => {
      const node = element('button', className, label);
      node.type = 'button'; node.addEventListener('click', handler); return node;
    };
    const safeUrl = (value) => {
      try { const url = new URL(value, location.href); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; }
      catch (_) { return ''; }
    };
    const header = element('header', 'osn-cart-panel__header');
    const heading = element('h2', '', text.title); heading.id = 'osn-cart-panel-title';
    const close = button('×', dismiss, 'osn-cart-panel__close'); close.setAttribute('aria-label', text.close);
    header.append(heading, close);
    const body = element('div', 'osn-cart-panel__body');
    const status = element('p', 'osn-cart-panel__status'); status.setAttribute('role', 'status');
    const error = element('p', 'osn-cart-panel__error'); error.setAttribute('role', 'alert'); error.hidden = true;
    const items = element('ul', 'osn-cart-panel__items');
    const summary = element('div', 'osn-cart-panel__summary');
    const footer = element('footer', 'osn-cart-panel__footer');
    const checkout = button(text.checkout, () => {
      observe('checkout_click');
      if (!cart?.plantMinimum?.blocked) options.checkout();
    }, 'osn-cart-panel__checkout');
    checkout.disabled = true;
    const fullCart = element('a', '', text.fullCart); fullCart.href = options.cartUrl;
    const keepShopping = button(text.continue, dismiss, 'osn-cart-panel__continue');
    const service = element('p', 'osn-cart-panel__service');
    const tier = element('p','osn-cart-panel__tier');tier.hidden=true;tier.setAttribute('role','status');
    const bcQuiet=element('p','osn-cart-bc-quiet');bcQuiet.hidden=true;
    const minimum = element('div', 'osn-plant-minimum'); minimum.hidden = true; minimum.setAttribute('role', 'status');
    const shipping=window.OsnShippingEstimate?window.OsnShippingEstimate({text:window.OsnShippingEstimate.copy(text),locale:options.locale,money:amount=>money(Math.round(amount*100)),quote:(address,signal)=>window.OsnShippingEstimate.nativeQuote(address,signal),remove:key=>change(key,0)}):null;
    footer.append(summary, tier, service, minimum, bcQuiet);if(shipping)footer.append(shipping.warning,shipping.element);footer.append(checkout,fullCart,keepShopping);
    body.append(status, error, items); const content=element('div','osn-cart-panel__content');content.append(body,footer);dialog.append(header,content);shipping?.element.addEventListener('toggle',()=>dialog.classList.toggle('is-estimating',shipping.element.open)); document.body.append(dialog);
    let cart = null, pending = false, generation = 0, controller = null, opener = null;
    let historyOwned = false;
    const token = 'osn-cart-panel-' + Math.random().toString(36).slice(2);
    const money = cents => new Intl.NumberFormat(options.locale, {style: 'currency', currency: cart.currency, currencyDisplay: cart.currency === 'CAD' ? 'narrowSymbol' : 'symbol'}).format(cents / 100);
    function observe(action) {
      // Optional instrumentation must never own or interrupt a cart operation.
      try { options.observe?.(action, {item_count:cart.items.reduce((sum, item) => sum + item.quantity, 0)}); }
      catch (_) { /* Analytics failure must not affect shopping. */ }
    }
    function validate(value) {
      if (!value || !Array.isArray(value.items) || !/^[A-Z]{3}$/.test(value.currency) ||
          !Number.isSafeInteger(value.total_price) || value.total_price < 0 ||
          !Number.isSafeInteger(value.total_discount) || value.total_discount < 0 ||
          value.items.some(item => !item.key || typeof item.title !== 'string' ||
            !Number.isSafeInteger(item.quantity) || item.quantity < 1 ||
            !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0)) throw new Error('Invalid cart');
      return value;
    }
    function setBusy(value) {
      pending = value;if(value)shipping?.setCart(null); items.setAttribute('aria-busy', String(value));
      items.querySelectorAll('button').forEach(node => { node.disabled = value; });
      checkout.disabled = value || !cart || !cart.items.length || !!cart.plantMinimum?.blocked;
      window.OsnPlantMinimum?.render(minimum, cart?.plantMinimum, cart?.currency);
      window.OsnPlantTerms?.renderSuggestions(minimum,cart?.plantMinimum?.suggestions,options.locale);
      const qualified=window.OsnPlantTerms?.copy[window.OsnPlantTerms.language(options.locale)];bcQuiet.textContent=qualified&&cart?.plantMinimum?.plantCount>0?qualified['cart.bc.quiet']:'';bcQuiet.hidden=!bcQuiet.textContent;
      tier.textContent=window.OsnCartTierProgress?.(cart,options.locale)||'';tier.hidden=!tier.textContent;
    }
    function render() {
      items.replaceChildren(); summary.replaceChildren();shipping?.setCart(cart);
      if (!cart.items.length) { status.textContent = text.empty; service.textContent = ''; setBusy(false); return; }
      const count = cart.items.reduce((total, item) => total + item.quantity, 0);
      const countLabel = cart.items.every(item => item.kind === 'seed') ? (count === 1 ? text.onePacket : text.packets) : (count === 1 ? text.oneItem : text.items);
      status.textContent = countLabel.replace('{count}', String(count));
      cart.items.forEach(item => {
        const row = element('li', 'osn-cart-panel__item'); row.dataset.key = item.key;
        const image = element('img'); image.alt = ''; image.width = 72; image.height = 72;
        if (safeUrl(item.image)) image.src = safeUrl(item.image);
        else image.hidden = true;
        image.addEventListener('error', () => { image.hidden = true; });
        const content = element('div', 'osn-cart-panel__item-content');
        const suffix=item.variantLabel ? ' - '+item.variantLabel : '';
        const displayTitle=suffix&&item.title.endsWith(suffix)?item.title.slice(0,-suffix.length):item.title;
        const title = element('a', 'osn-cart-panel__item-title', displayTitle); title.href = safeUrl(item.url) || options.cartUrl;
        const price = element('strong', 'osn-cart-panel__price', money(item.final_line_price));
        const controls = element('div', 'osn-cart-panel__controls');
        const quantity = element('div', 'osn-cart-panel__quantity');
        const minus = button('−', () => change(item.key, item.quantity - 1));
        minus.setAttribute('aria-label', text.decrease.replace('{title}', item.title));
        const number = element('span', '', String(item.quantity)); number.setAttribute('aria-label', text.quantity);
        const plus = button('+', () => change(item.key, item.quantity + 1));
        plus.setAttribute('aria-label', text.increase.replace('{title}', item.title));
        quantity.append(minus, number, plus);
        const remove = button(text.remove, () => change(item.key, 0), 'osn-cart-panel__remove');
        remove.setAttribute('aria-label', text.remove + ': ' + item.title);
        controls.append(quantity, remove); content.append(title);
        if (item.variantLabel) content.append(element('p', 'osn-cart-panel__fine', item.variantLabel));
        content.append(price, controls); row.append(image, content); items.append(row);
      });
      const subtotal = element('p', 'osn-cart-panel__total');
      subtotal.append(element('span', '', text.subtotal), element('strong', '', money(cart.total_price)));
      summary.append(subtotal);
      if (cart.total_discount > 0) {
        const savings = element('p', 'osn-cart-panel__savings', text.savings.replace('{amount}', money(cart.total_discount)));
        summary.append(savings);
      }
      const dispatch = cart.items.every(item => item.kind === 'seed') ? text.seedDispatch : text.mixedDispatch;
      service.replaceChildren(element('span', '', cart.taxes_included && text.shippingTaxIncluded ? text.shippingTaxIncluded : text.shipping));
      setBusy(pending);
    }
    async function request(fn) {
      const activeController = new AbortController(); controller = activeController;
      let timer;
      try {
        return validate(await Promise.race([
          fn(activeController.signal),
          new Promise((_, reject) => { timer = setTimeout(() => { activeController.abort(); reject(new Error('Timeout')); }, options.timeout || 10000); })
        ]));
      } finally { clearTimeout(timer); if (controller === activeController) controller = null; }
    }
    async function refresh() {
      const current = ++generation;
      cart = null; items.replaceChildren(); summary.replaceChildren(); service.replaceChildren(); error.hidden = true;
      status.textContent = text.loading; setBusy(true);
      try {
        const value = await request(signal => options.adapter.read(signal));
        if (current !== generation || !dialog.open) return;
        cart = value; pending = false; render(); observe('view');
      } catch (_) {
        if (current !== generation || !dialog.open) return;
        status.textContent = ''; error.textContent = text.loadError; error.hidden = false; setBusy(false);
      }
    }
    async function change(key, quantity) {
      if (pending || !cart) return;
      const focused = document.activeElement?.getAttribute('aria-label');
      const current = generation;
      error.hidden = true; status.textContent = text.updating; setBusy(true);
      try {
        const value = await request(signal => options.adapter.change(key, quantity, signal));
        if (current !== generation || !dialog.open) return;
        cart = value; pending = false; render();
      } catch (_) {
        // A failure can follow a provider mutation. Never repeat the mutation.
        // Re-read only; if that fails too, do not offer checkout from stale data.
        if (current !== generation || !dialog.open) return;
        try {
          const value = await request(signal => options.adapter.read(signal));
          if (current !== generation || !dialog.open) return;
          cart = value; pending = false; render();
        } catch (_) {
          if (current !== generation || !dialog.open) return;
          cart = null; items.replaceChildren(); summary.replaceChildren(); service.replaceChildren(); status.textContent = ''; setBusy(false);
        }
        error.textContent = text.changeError; error.hidden = false;
      }
      if (current === generation && dialog.open) {
        const target = [...items.querySelectorAll('button')].find(node => node.getAttribute('aria-label') === focused);
        (target || close).focus({preventScroll: true});
      }
    }
    function closeOnly() {
      ++generation; controller?.abort();shipping?.dispose();
      if (dialog.open) dialog.close();
      if (opener?.isConnected) opener.focus({preventScroll: true});
    }
    function dismiss() {
      closeOnly();
      if (historyOwned && history.state?.osnCartPanel === token) history.back();
      historyOwned = false;
    }
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const targets = [...dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), summary')].filter(node => node.getClientRects().length);
      const first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // Close only when both pointer ends are on the backdrop, never after dragging a control.
    let backdropStart = false, backdropEnd = false;
    const outside = event => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    dialog.addEventListener('pointerdown', event => { backdropStart = outside(event); backdropEnd = false; });
    dialog.addEventListener('pointerup', event => { backdropEnd = backdropStart && outside(event); backdropStart = false; });
    dialog.addEventListener('pointercancel', () => { backdropStart = false; backdropEnd = false; });
    // Keep the modal present until click is consumed: closing on pointerup can
    // let Safari's subsequent click steal restored focus or reach the page below.
    dialog.addEventListener('click', event => {
      if (!backdropEnd) return;
      backdropEnd = false; event.preventDefault(); event.stopPropagation(); dismiss();
    });
    window.addEventListener('popstate', () => {
      if (dialog.open && history.state?.osnCartPanel !== token) { historyOwned = false; closeOnly(); }
    });
    return {
      open(trigger) {
        if (dialog.open) return;
        opener = trigger || document.activeElement;
        dialog.showModal(); close.focus({preventScroll: true});
        try { history.pushState({...history.state, osnCartPanel: token}, ''); historyOwned = true; } catch (_) { historyOwned = false; }
        refresh();
      },
      close: dismiss,
      dialog
    };
  };
})();

/* Production adapter. Uses Shopify cart state and existing localized cart markup.
   No fixture prices, products, translated titles or discount arithmetic. */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  const settings = window.OSN_THEME;
  if (!settings?.locale?.cartPanel || !window.OsnCartPanel || !window.HTMLDialogElement?.prototype.showModal) return;
  const cartUrl = settings.cartUrl || '/cart';
  if (location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '')) return;
  // Shopify does not expose this API until requested. Load once in parallel;
  // never await it, change consent, or replay interactions from before readiness.
  try {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
    }
  } catch (_) { /* Cart remains usable without analytics. */ }
  let panel;
  const normalizedPath = url => {
    const parsed = new URL(url, location.href);
    if (parsed.origin !== location.origin) throw new Error('Unexpected cart route');
    return parsed;
  };
  const root = cartUrl.replace(/cart\/?$/, '');
  async function getJson(url, signal, extra) {
    const response = await fetch(normalizedPath(url), {credentials:'same-origin',cache:'no-store',signal,...extra});
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  function normalize(cart, sections) {
    if (!cart || !Array.isArray(cart.items) || typeof sections?.['main-cart-items'] !== 'string') throw new Error('Missing cart section');
    const doc = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
    const rows = [...doc.querySelectorAll('[data-osn-panel-key]')];
    if (rows.length !== cart.items.length) throw new Error('Cart changed between reads');
    const items = cart.items.map(item => {
      const row = rows.find(node => node.dataset.osnPanelKey === item.key);
      const title = row?.querySelector('.cart-item__name')?.textContent.trim().replace(/\s+/g,' ');
      const quantity = Number(row?.querySelector('input[name="updates[]"]')?.value);
      if (!title || quantity !== item.quantity) throw new Error('Cart markup is stale');
      // Do not hide custom shipping instructions, uploads or subscription terms.
      // Complex carts retain the complete existing full-cart experience.
      if (item.selling_plan_allocation || Object.keys(item.properties || {}).some(key => key[0] !== '_')) throw new Error('Full cart required for custom line details');
      return {...item, title, kind:row.dataset.osnPanelKind,
        variantLabel:item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        image:typeof item.image === 'string' ? item.image : item.featured_image?.url || '',
        url:root + item.url.replace(/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?/, '')};
    });
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      bubble.querySelectorAll('.tool-button__count,.cart-count-bubble').forEach(node => node.remove());
      if (cart.item_count > 0) {
        const count = document.createElement('span'); count.className = 'tool-button__count'; count.textContent = cart.item_count; bubble.appendChild(count);
      }
    }
    if (typeof refreshOsnCardCartState === 'function') refreshOsnCardCartState();
    const policy = doc.querySelector('[data-osn-plant-minimum-state]');
    if (!policy) throw new Error('Missing plant minimum state');
    return {...cart, items, plantMinimum:JSON.parse(policy.textContent)};
  }
  const adapter = {
    async read(signal) {
      const [cart, sections] = await Promise.all([
        getJson(cartUrl + '.js', signal), getJson(cartUrl + '?sections=main-cart-items', signal)
      ]);
      return normalize(cart, sections);
    },
    async change(key, quantity, signal) {
      const cart = await getJson(root + 'cart/change.js', signal, {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity,sections:['main-cart-items'],sections_url:cartUrl})
      });
      return normalize(cart, cart.sections);
    }
  };
  panel = window.OsnCartPanel({
    text:settings.locale.cartPanel, locale:document.documentElement.lang || 'en', cartUrl, adapter,
    observe(action, counts) {
      // Existing browsing-property owner, deliberately not an ecommerce event.
      // Missing/denied privacy state means no send and no later replay.
      if (!['view', 'checkout_click'].includes(action) ||
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true ||
          typeof window.gtag !== 'function') return;
      window.gtag('event', 'osn_cart_panel_' + action, {
        send_to:'G-QDH0E1G2RS', cart_surface:'drawer',
        language:document.documentElement.lang || 'en', item_count:counts.item_count,
        transport_type:'beacon'
      });
    },
    checkout() {
      // Native checkout submission, like the full cart. Shopify owns payment,
      // discounts and purchase tracking. No extra begin_checkout event here.
      const form = document.createElement('form'); form.method = 'post'; form.action = cartUrl;
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = 'checkout';
      form.appendChild(input); document.body.appendChild(form); form.submit();
    }
  });
  panel.dialog.setAttribute('data-osn-live-cart-panel', '');
  document.addEventListener('click', event => {
    const link = event.target.closest('#cart-icon-bubble,.osn-cart-toast a,[data-osn-in-cart],[data-osn-assortment-cart],[data-osn-wishlist-cart]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (normalizedPath(link.href).pathname !== cartUrl) return;
    // Keep existing drawer focus/scroll ownership exclusive.
    if (document.querySelector('.oak-wishlist-drawer.is-open,[data-osn-wishlist-drawer].is-open') || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('is-locked')) return;
    event.preventDefault(); panel.open(link);
  });
});

/* OSN_CART_PANEL_GENERATED_END */

/* OSN_ASSORTMENT_START */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-osn-assortment]').forEach(function (section) {
    const text=JSON.parse(section.querySelector('[data-assortment-copy]').textContent);
    const inputs=[...section.querySelectorAll('[data-assortment-choice] input')];
    const add=section.querySelector('[data-assortment-add]'),status=section.querySelector('[data-assortment-status]');
    const cartUrl=section.dataset.cartUrl;
    let busy=false,locked=false,lastSelection=[];
    const repeat=document.createElement('button');
    repeat.type='button';repeat.dataset.assortmentRepeat='';repeat.textContent=text.repeat;repeat.hidden=true;
    add.after(repeat);
    const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:section.dataset.currency});
    function update(){
      const selected=inputs.filter(input=>input.checked&&!input.disabled);
      const total=section.querySelector('[data-assortment-total]');
      total.textContent=money.format(selected.reduce((sum,input)=>sum+Number(input.dataset.price),0)/100);
      (section.querySelector('[data-assortment-total-line]')||total).hidden=!selected.length;
      add.disabled=busy||locked||!selected.length;
      repeat.hidden=locked||!lastSelection.length||selected.length>0;
      repeat.disabled=busy;
    }
    async function request(url,options){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
      try{
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:controller.signal});
        if(!response.ok)throw Error('Cart request failed');
        return await response.json();
      }finally{clearTimeout(timer);}
    }
    function quantities(cart){
      if(!Array.isArray(cart?.items))throw Error('Invalid cart');
      const counts={};
      cart.items.forEach(item=>{if(!Number.isInteger(item.quantity)||item.quantity<0)throw Error('Invalid quantity');counts[item.variant_id]=(counts[item.variant_id]||0)+item.quantity;});
      return counts;
    }
    function showQuantities(cart){
      const counts=quantities(cart);
      inputs.forEach(input=>{
        const n=counts[input.value]||0;
        input.closest('[data-assortment-item]').querySelector('[data-assortment-result]').textContent=n?text.inCart.replace('[[count]]',String(n)):'';
      });
    }
    document.addEventListener('osn:cart-items',event=>{
      if(busy||locked)return;
      try{showQuantities(event.detail);}catch(_error){/* Unverified data must not change confirmed cart hints. */}
    });
    section.querySelectorAll('[data-assortment-choice]').forEach(node=>node.hidden=false);
    section.querySelector('.osn-assortment__actions').hidden=false;
    inputs.forEach(input=>input.addEventListener('change',update));update();
    repeat.addEventListener('click',()=>{
      if(busy||locked)return;
      inputs.forEach(input=>{input.checked=lastSelection.includes(input.value);});
      update();add.click();
    });
    add.addEventListener('click',async function(){
      if(busy||locked)return;
      const selected=inputs.filter(input=>input.checked&&!input.disabled);
      if(!selected.length){status.textContent=text.empty;return;}
      busy=true;update();inputs.forEach(input=>input.disabled=true);add.setAttribute('aria-busy','true');status.textContent='';
      let submitted=false;
      try{
        const before=quantities(await request(cartUrl+'.js'));
        submitted=true;
        // One batch request only. A failed/ambiguous reply is never blindly retried.
        try{await request(cartUrl+'/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selected.map(input=>({id:Number(input.value),quantity:1}))})});}catch(_error){/* Read the actual cart even after a 422 or transport failure. */}
        const cart=await request(cartUrl+'.js'),after=quantities(cart);
        let confirmed=0;
        selected.forEach(input=>{
          const delta=(after[input.value]||0)-(before[input.value]||0);
          const result=input.closest('[data-assortment-item]').querySelector('[data-assortment-result]');
          if(delta===1){confirmed++;input.checked=false;result.textContent=text.inCart.replace('[[count]]',String(after[input.value]));}
          else result.textContent=text.notAdded;
        });
        locked=confirmed!==selected.length;
        if(!locked)lastSelection=selected.map(input=>input.value);
        status.textContent=locked?text.partial:(confirmed===1?text.addedOne:text.addedMany.replace('[[count]]',String(confirmed)));
        section.dataset.assortmentOutcome=locked?'uncertain':'added';
        section.dispatchEvent(new CustomEvent('osn:assortment-result', {bubbles:true, detail:{outcome:locked?'uncertain':'added', confirmed}}));
        // Existing theme owns count refresh. No duplicate ecommerce event or forced drawer.
        if(typeof refreshOsnCardCartState==='function')refreshOsnCardCartState();
        const cartLink=document.querySelector('#cart-icon-bubble');
        if(cartLink){
          let bubble=cartLink.querySelector('.tool-button__count');
          if(!bubble){bubble=document.createElement('span');bubble.className='tool-button__count';cartLink.appendChild(bubble);}
          bubble.textContent=String(cart.item_count);
        }
      }catch(_error){
        locked=submitted;status.textContent=submitted?text.partial:text.failed;
        section.dataset.assortmentOutcome=submitted?'uncertain':'failed';
      }finally{busy=false;inputs.forEach(input=>input.disabled=locked);add.removeAttribute('aria-busy');update();}
    });
  });
});
/* OSN_ASSORTMENT_END */

/* OSN_FEATURE_MEASUREMENT_START */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-osn-feature]').forEach(function (feature) {
    let exposed = false, timer;
    const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.gtag === 'function';
    function record(action, extra = {}) {
      if (!allowed() || document.visibilityState !== 'visible') return false;
      window.gtag('event', 'osn_feature_' + action, {
        send_to:'G-QDH0E1G2RS', feature_id:feature.dataset.osnFeature,
        feature_version:feature.dataset.featureVersion,
        feature_week:feature.dataset.featureWeek,
        feature_placement:feature.dataset.featurePlacement,
        language:document.documentElement.lang || 'en',
        ...extra, transport_type:'beacon'
      });
      return true;
    }
    // A visible heading/card area for one second, not the entire tall section.
    // No consent means no queued replay and no personal identifiers.
    const target = feature.querySelector('h2');
    if (target && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        clearTimeout(timer);
        if (!exposed && entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .5)) {
          timer = setTimeout(() => {
            if (exposed) return;
            exposed = record('view', {suppressed:feature.dataset.featureSuppressed || ''});
            if (exposed) observer.disconnect();
          }, 1000);
        }
      }, {threshold:.5});
      observer.observe(target);
      document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(timer); });
    }
    feature.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (link) {
        // Only catalog destination paths, never query strings or cart contents.
        const url = new URL(link.href, location.href);
        if (url.origin === location.origin && /\/products\//.test(url.pathname)) record('product_click', {destination:url.pathname});
      }
      if (event.target.closest('[data-comparison-toggle]')) record('compare');
    });
    feature.addEventListener('change', event => {
      if (event.target.matches('[data-assortment-choice] input')) record('selection', {selected:event.target.checked ? 1 : 0});
    });
    feature.addEventListener('osn:assortment-result', event => {
      const detail = event.detail || {};
      if (Number.isInteger(detail.confirmed) && detail.confirmed >= 0 && ['added','uncertain'].includes(detail.outcome)) {
        record('cart_result', {outcome:detail.outcome, confirmed:detail.confirmed});
      }
    });
  });
});
/* OSN_FEATURE_MEASUREMENT_END */

/* OSN_COMPARISON_DETAILS_START */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-seed-comparison]').forEach(section => {
    const cards = [...section.querySelectorAll('[data-comparison-product]')];
    const button = section.querySelector('[data-comparison-toggle]');
    const panel = section.querySelector('[data-comparison-panel]');
    if (cards.length < 2 || !button || !panel) return;
    const rail = section.querySelector('.osn-assortment__items');
    const hint = section.querySelector('.osn-assortment__swipe');
    const labels = [...panel.querySelectorAll('[data-comparison-label]')];
    const fields = labels.map(label => ({key: label.dataset.comparisonLabel, label: label.textContent}));
    const products = cards.map(card => ({
      title: card.querySelector('.osn-assortment__title').textContent.trim(),
      href: card.querySelector('.osn-assortment__title').getAttribute('href'),
      facts: Object.fromEntries(fields.map(field => [field.key, card.querySelector('[data-comparison-fact="'+field.key+'"]').textContent.trim()]))
    }));
    const make = (tag, text) => { const node = document.createElement(tag); if (text) node.textContent = text; return node; };
    const table = make('table');
    table.setAttribute('aria-labelledby', section.getAttribute('aria-labelledby'));
    const head = table.createTHead().insertRow();
    const selects = [], links = [], cells = [];
    [panel.dataset.firstLabel, panel.dataset.secondLabel].forEach((text, column) => {
      const th = make('th'); th.scope = 'col'; th.id = panel.id+'-choice-'+column;
      const label = make('label', text), select = make('select');
      select.id = panel.id+'-select-'+column; label.htmlFor = select.id;
      products.forEach((product, index) => { const option = make('option', product.title); option.value = String(index); select.append(option); });
      const link = make('a');
      th.append(label, select, link); head.append(th); selects.push(select); links.push(link);
    });
    const body = table.createTBody();
    fields.forEach(field => {
      const header = make('th', field.label); header.colSpan = 2; header.id = panel.id+'-'+field.key;
      body.insertRow().append(header);
      const row = body.insertRow();
      cells.push([0, 1].map(column => { const cell = row.insertCell(); cell.setAttribute('headers', header.id+' '+panel.id+'-choice-'+column); return cell; }));
    });
    const current = cards.findIndex(card => card.hasAttribute('data-comparison-current'));
    selects[0].value = String(Math.max(0, current));
    selects[1].value = selects[0].value === '0' ? '1' : '0';
    function update(changed) {
      if (selects[0].value === selects[1].value) selects[1-changed].value = String(products.findIndex((_, i) => String(i) !== selects[changed].value));
      selects.forEach((select, column) => {
        const product = products[Number(select.value)];
        [...select.options].forEach(option => option.disabled = option.value === selects[1-column].value);
        links[column].textContent = product.title; links[column].href = product.href;
        fields.forEach((field, index) => cells[index][column].textContent = product.facts[field.key]);
      });
    }
    selects.forEach((select, index) => select.addEventListener('change', () => update(index)));
    update(0); panel.append(table);
    const compareLabel = button.textContent;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.photosLabel : compareLabel;
      panel.hidden = !expanded; rail.hidden = expanded; if (hint) hint.hidden = expanded;
    });
    button.hidden = false;
  });
});
/* OSN_COMPARISON_DETAILS_END */
